/**
 * @Author: wence@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 16:01:23
 * @FilePath: /m-anquan-baidu-com/src/containers/product/page_inspection.js
 * @Description: 园区智慧巡检
 */
import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import cn from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ProductTitle from '../../components/ProductTitle';
import ProBanner from '../../components/ProBanner';
import {fetchChackAiIndustry, getInstanceId} from '../../actions/productAction';

import confirmBox from '../../components/Confirmation';
import AiScan from './components/aiScan';

import './page_imagerecognition.less';

class PageInspection extends PureComponent {
    static propTypes = {
        bannerInfo: PropType.object,
        fetchChackAiIndustry: PropType.func,
        checkAiInsdustryData: PropType.object,
        userLoginstate: PropType.object
    }

    constructor(props) {
        super(props);

        this.state = {
            instanceId: ''
        };
    }

    async componentDidMount() {
        const res = await getInstanceId();

        if (res.status === 0) {
            this.setState({instanceId: Object.keys(res.data)[0]});
        }
    }

    afterResponse = res => {
        if (res.status === 4040001) {
            confirmBox({
                okText: '立即申请',
                concelText: '取消',
                onOk: () => {
                    window.location.href = '/m/apply-inspection?url=' + encodeURIComponent(window.location.pathname);
                },
                renderBody: () => {
                    return (
                        <div>
                            <div className="title" style={{fontSize: '.48rem', marginBottom: '.2rem'}}>
                                免费体验次数限制提示
                            </div>
                            <div className="content">
                                普通用户支持每天试用10次，申请审核通过后，您可获得每天免费体验50次的权限。
                            </div>
                        </div>
                    );
                }
            });
        } else if (res.status === 4040002) {
            confirmBox({
                okText: '立即申请',
                concelText: '取消',
                onOk: () => {
                    window.location.href = '/console/#/inspectionApply';
                },
                renderBody: () => {
                    return (
                        <div>
                            <div className="title" style={{fontSize: '.48rem', marginBottom: '.2rem'}}>
                                免费体验次数限制提示
                            </div>
                            <div className="content">
                                当前免费体验次数已用完，体验更多检测能力可申请POC
                            </div>
                        </div>
                    );
                }
            });
        }
    }

    render() {
        const bannerInfo = this.props.bannerInfo || {};
        const productList = [
            {
                'mobile_pic': require('../../asset/image/page_inspection/icon_anquanmaojiance.png'),
                title: '安全帽合规检测',
                content: '工业厂区生产环境复杂，安全帽佩戴对保障人员安全至关重要。针对视频内容，实时检测出工地人员，并判断是否佩戴安全帽，当未佩戴安全帽时，及时报警，规范着装要求，降低作业风险。'
            },
            {
                'mobile_pic': require('../../asset/image/page_inspection/iocn_weixianxingwei.png'),
                title: '危险行为检测',
                content: '根据图片或实时监控视频，识别工作人员是否存在抽烟打电话行为，若存在，及时报警，降低火灾风险，营造安全作业环境。'
            }
        ];
        const senceList = [
            {
                'mobile_pic': require('../../asset/image/page_inspection/sence1.png'),
                title: '工业园区',
                content: '聚焦安全生产问题，从人员着装规范和厂区生产环境两个方面，为生产安全提供保障。智能化监控未佩戴安全帽行为，降低着装违规风险，高效捕捉抽烟打电话行为，为生产环境安全提供进一步保障。'
            },
            {
                'mobile_pic': require('../../asset/image/page_inspection/sence2.png'),
                title: '加油站',
                content: '检测加油服务场景中是否存在抽烟打电话行为，高效识别并及时报警，降低加油站火灾风险。'
            },
            {
                'mobile_pic': require('../../asset/image/page_inspection/sence3.png'),
                title: '餐厅商店等营业场所',
                content: '在餐厅商店等公共区域，抽烟行为会影响其他顾客就餐以及购物体验并有火灾风险，高效识别抽烟行为并报警，营造良好的营业环境，增加顾客满意度。'
            }
        ];

        const proinfoBox = [
            {
                'mobile_pic': require('../../asset/image/page_inspection/icon_jiancejishu.svg'),
                title: '领先的检测技术',
                content: '依托百度安全在检测领域的丰富技术积累和不断更新的技术能力，保障检测服务的领先能力。'
            },
            {
                'mobile_pic': require('../../asset/image/page_inspection/icon_zhunquelv.svg'),
                title: '识别准确率高',
                content: '依托百度安全的算法积累和工业原始训练数据积累，模型准确率和召回率行业领先。'
            },
            {
                'mobile_pic': require('../../asset/image/page_inspection/icon_jichengbushu.svg'),
                title: '易于集成部署',
                content: '提供完善的组件化SDK、API接口、配置后台，根据业务场景和需求灵活配置部署。'
            }
        ];

        const {userLoginstate} = this.props;
        return (
            <div className="product">
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>

                <div className={'product-des'}>
                    基于百度AI图像识别技术，集成各类摄像头、无人机、机器人、AI芯片及巡检场景模型，
                    实现对工业生产场景生产作业、设备状态、人员安全的智能监控和实时预警，帮助企业实现安全生产，
                    提高监管效率，减少人力成本
                </div>

                <div className="product-mod">
                    <ProductTitle title="产品功能" />
                </div>

                <div className="product-mod">
                    {
                        productList.map((item, index) => {
                            return <div
                                key={index}
                                className="proinfo-box mui-flex"
                                style={{borderBottom: 0, paddingTop: 0, paddingBottom: '.8rem'}}>
                                <div className="proinfo-box-icon" style={{height: '1.8rem', width: '2.2rem'}}>
                                    <img
                                        src={item.mobile_pic}
                                        width={'100%'}
                                        alt={item.title}
                                    />
                                </div>
                                <div className="cell">
                                    <div
                                        className="proinfo-box-title"
                                        style={{marginBottom: '0.1rem'}}>
                                        {item.title}
                                    </div>
                                    <div className="proinfo-box-des">
                                        {item.content}
                                    </div>
                                </div>
                            </div>;
                        })
                    }
                </div>

                <div className="product-mod">
                    <ProductTitle title="功能体验" />
                </div>

                <div className="product-function product-inspection-scan">
                    <AiScan
                        hiddenUrl
                        onUploadBtnClick={e => {
                            if (!(userLoginstate && userLoginstate.status === 0)) {
                                e.stopPropagation();
                                e.preventDefault();
                                window.location.href = this.loginUrl();
                            }
                        }}
                        afterResponse={this.afterResponse}
                        renderResultList={(resultList, isFetch) => {
                            if (!isFetch) {
                                return '';
                            }
                            const errList = resultList.filter(item => item.name === 'none') || [];
                            return `${errList.length}处异常`;
                        }}
                        responseFormater={data => {
                            const list = [];

                            data.results.forEach((item, index) => {
                                if (item.attrib && item.attrib.length > 0) {
                                    item.attrib.forEach((attr, attrIndex) => {
                                        const defaultColor = attr.name === 'none' ? '#F5535B' : '#40C87F';
                                        list.push({
                                            location: attr.location,
                                            score: attr.score,
                                            textColor: defaultColor,
                                            name: attr.name,
                                            strokeStyle: defaultColor,
                                            text: attrIndex + index + 1
                                        });
                                    });
                                }
                            });

                            return list;
                        }}
                        beforeFetch={data => {
                            return {
                                image: (data.upload_url || '').split(',')[1] || data.upload_url,
                                'key_id': data.key_id,
                                'instance_id': this.state.instanceId,
                                sign: data.sign,
                                data: data.data,
                                model: 'anquanmao',
                                type: 0
                            };
                        }}
                        fetchChackAiImage={this.props.fetchChackAiIndustry}
                        checkAiImageData={this.props.checkAiInsdustryData} />
                </div>

                <div>
                    <div className="product-mod">
                        <ProductTitle title="适用场景" />
                    </div>
                    <div className={'product-mod'}>
                        {
                            senceList.map((item, index) => {
                                return <div
                                    className={'pro-applicable'}
                                    key={index}
                                    style={{
                                        backgroundImage: `url(${item.mobile_pic})`,
                                        height: index === 0 ? '3.96rem' : '3.46rem',
                                        backgroundSize: 'contain',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        paddingTop: 0
                                    }}
                                >
                                    <div className={'pro-app-title'}>
                                        {item.title}
                                    </div>
                                    <div className={'pro-app-content'}>
                                        {item.content}
                                    </div>
                                </div>;
                            })
                        }
                    </div>
                </div>

                <div className="product-mod">
                    <ProductTitle title="产品特色" />
                </div>

                <div className={'product-mod'}>
                    {
                        proinfoBox.map((item, index) => {
                            const style = index === 2 ? {borderBottom: 0} : null;
                            return <div key={index} className="proinfo-box mui-flex" style={style}>
                                <div className={'proinfo-box-icon'}>
                                    <img
                                        src={item.mobile_pic}
                                        width={'100%'}
                                        alt={item.title}
                                    />
                                </div>
                                <div className={'cell'}>
                                    <div className={'proinfo-box-title'}>{item.title}</div>
                                    <div className={'proinfo-box-des'}>
                                        {item.content}
                                    </div>
                                </div>
                            </div>;
                        })
                    }
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({checkAiInsdustryData: state.checkAiInsdustryData, userLoginstate: state.userLoginstate}),
    dispatch => bindActionCreators({fetchChackAiIndustry}, dispatch)
)(PageInspection);



// WEBPACK FOOTER //
// ./src/containers/product/page_inspection.js